import React from 'react'
import {titlecase} from 'admin/lib/format'
import _ from 'lodash'

export default ({name, label, value, text, onChange, isHorizontal = false}) => {
  const handleChange = () => onChange({[name]: !value})

  return isHorizontal ? (
    <div className='field is-horizontal is-align-items-flex-start'>
      <div className='field-label is-small has-text-left is-flex-grow-2'>
        <label htmlFor={name} className='label is-small'>
          {label || titlecase(name)}
        </label>
      </div>
      <div className='field-body'>
        <label className={`switch ${_.isNil(value) ? '' : value ? 'on' : 'off'}`}>
          <input type='checkbox' checked={value} name={name} onChange={handleChange} id={name} />
          <span className='slider'></span>
          <span>{text || (value ? 'On' : 'Off')}</span>
        </label>
      </div>
    </div>
  ) : (
    <div className='field'>
      <label htmlFor={name} className='label is-small'>
        {label || titlecase(name)}
      </label>
      <div className='control'>
        <label className={`switch ${_.isNil(value) ? '' : value ? 'on' : 'off'}`}>
          <input type='checkbox' checked={value} name={name} onChange={handleChange} id={name} />
          <span className='slider'></span>
          <span>{text || (value ? 'On' : 'Off')}</span>
        </label>
      </div>
    </div>
  )
}
